import Vue from 'vue'
import Router from 'vue-router'
import pcRouter from './module/pcRouter'
import h5Router_r from './module/h5Router_r'
import h5Router_d from './module/h5Router_d'

Vue.use(Router)

let router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...pcRouter,
        ...h5Router_r,
        ...h5Router_d,
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
})

router.afterEach(() => {
    // alert(123)
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
})

export default router;
